import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/minicity_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-2c93c1b3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "loginContainer is-flex-grow-1"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loginImageMobile" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Minicity Logo",
  src: _imports_0,
  class: "logoImage ml-3 mr-3"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "infoNote" }, [
    /*#__PURE__*/_createElementVNode("p", null, "This site is for citizens to access Mini City services."),
    /*#__PURE__*/_createElementVNode("p", { class: "pt-1" }, [
      /*#__PURE__*/_createTextVNode("Caseworkers / partners, please use "),
      /*#__PURE__*/_createElementVNode("a", {
        class: "infoLink",
        href: "https://portal.minicityatl.com"
      }, "portal.minicityatl.com"),
      /*#__PURE__*/_createTextVNode(".")
    ])
  ])
], -1))
const _hoisted_5 = { class: "pt-5" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Username", -1))
const _hoisted_7 = { class: "pt-5" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Password", -1))
const _hoisted_9 = { class: "pt-5" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 0,
  class: "notification bulmaNotification is-warning"
}
const _hoisted_12 = {
  key: 1,
  class: "errorNotification"
}
const _hoisted_13 = {
  key: 2,
  class: "errorNotification"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loginImageDesktop" }, null, -1))
const _hoisted_15 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_16 = {
  key: 1,
  class: "columns is-loading"
}
const _hoisted_17 = { class: "pt-5" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Please enter your username to reset your password", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "p-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "NOTE: "),
  /*#__PURE__*/_createTextVNode(" If you didn't provide an email address when registering with Mini City, you'll need to ask your caseworker to reset your password for you.")
], -1))

import { reactive, getCurrentInstance, onMounted } from "vue";
import { useRoute } from "vue-router";
import { login, initiatePasswordReset } from "@/core/session"
import { mapHttpError, notifyError, notifyNetworkError, notifySuccess } from "@/core/utils";
import { CONFIG } from "@/core/config";
import { Validations } from "@/composables/useValidation";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const instance = getCurrentInstance();

const forwardTo = useRoute().query.forwardTo;
const postLoginURL = forwardTo?.length ? forwardTo.toString() : '/';

const loginState = reactive({
  username: "",
  password: "",
  inProgress: false,
  error: "",
  isAutoLogout: useRoute().query.autoLogout == 'true'
});

const doLogin = () => {
  loginState.isAutoLogout = false;
  loginState.error = "";
  loginState.inProgress = true;

  login(loginState.username, loginState.password)
    .then(sess => {
      instance!.proxy!.$router.push(postLoginURL);
    })
    .catch(err => {
      loginState.error = err.response.status == 401 ? "Invalid username or password" : mapHttpError(err).message;
    })
    .finally(() => {
      loginState.inProgress = false;
    });
};

const isFormValid = (): boolean => {
  return (Validations.notEmpty(loginState.username) && Validations.notEmpty(loginState.password));
};

const passwordResetState = reactive({
  inProgress: false,
  shown: false,
  username: "",
});

const resetPassword = () => {
  passwordResetState.shown = true;
  passwordResetState.username = loginState.username;
};

const doResetPassword = () => {
  if (!(Validations.notEmpty(passwordResetState.username))) {
    notifyError("Please enter your username");
    return;
  }

  passwordResetState.inProgress = true;

  initiatePasswordReset(passwordResetState.username)
  .then(() => {
    notifySuccess("Please check your inbox for a link to reset your password!");
    passwordResetState.shown = false;
  })
  .catch(err => notifyNetworkError("Failed to reset password", err))
  .finally(() => passwordResetState.inProgress = false);
};


return (_ctx: any,_cache: any) => {
  const _component_LoadingPage = _resolveComponent("LoadingPage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppPageFrame = _resolveComponent("AppPageFrame")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppPageFrame, null, {
      default: _withCtx(() => [
        (loginState.inProgress)
          ? (_openBlock(), _createBlock(_component_LoadingPage, { key: 0 }))
          : (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _hoisted_2,
              _createElementVNode("form", {
                class: "loginForm",
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
              }, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Username",
                      class: "textInput",
                      autofocus: "",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginState.username) = $event))
                    }, null, 512), [
                      [_vModelText, loginState.username]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      placeholder: "Password",
                      class: "textInput",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginState.password) = $event))
                    }, null, 512), [
                      [_vModelText, loginState.password]
                    ])
                  ]),
                  _createElementVNode("a", {
                    class: "forgotPasswordLink",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (resetPassword()))
                  }, "Forgot your password?")
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      disabled: !isFormValid(),
                      class: "p-3 mt-3 ctaButton",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (doLogin()))
                    }, "Login", 8, _hoisted_10)
                  ])
                ]),
                (_unref(CONFIG)!.maintenanceMessage && _unref(CONFIG)!.maintenanceMessage.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(CONFIG)!.maintenanceMessage), 1))
                  : _createCommentVNode("", true),
                (loginState.error.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(loginState.error), 1))
                  : _createCommentVNode("", true),
                (loginState.isAutoLogout)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, "You have been automatically logged-out due to inactivity"))
                  : _createCommentVNode("", true)
              ], 32),
              _hoisted_14
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_ModalDialog, {
      active: passwordResetState.shown,
      title: "Reset Password",
      "allow-close": true,
      onClose: _cache[6] || (_cache[6] = ($event: any) => (passwordResetState.shown = false)),
      "first-button-text": "Go Back",
      "first-button-severity": "link",
      onFirstbuttonselected: _cache[7] || (_cache[7] = ($event: any) => (passwordResetState.shown = false)),
      "second-button-text": "Reset",
      "second-button-severity": "primary",
      onSecondbuttonselected: _cache[8] || (_cache[8] = ($event: any) => (doResetPassword()))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (passwordResetState.inProgress)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_LoadingSpinner, { size: "medium" })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Username",
                      class: _normalizeClass(["textInput", { 'is-danger': loginState.error.length > 0 }]),
                      autofocus: "",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((passwordResetState.username) = $event))
                    }, null, 2), [
                      [_vModelText, passwordResetState.username]
                    ])
                  ]),
                  _hoisted_19
                ])
              ]))
        ])
      ]),
      _: 1
    }, 8, ["active"])
  ], 64))
}
}

})